import { createFileRoute } from "@tanstack/react-router";
import SaintTmsTravelEs from "@/pages/es/SaintTmsTravelEs";
import {
  CLINIC_REF,
  buildBreadcrumbList,
  buildMedicalWebPage,
  SITE_URL,
} from "@/components/schemaConstants";
import { buildHreflang } from "@/lib/i18n/locale";

const ES_URL = `${SITE_URL}/es/saint-tms-travel`;
const BREADCRUMB_ID = `${ES_URL}#breadcrumb`;

export const Route = createFileRoute("/es/saint-tms-travel")({
  head: () => ({
    meta: [
      {
        title: "Viaje a Coral Springs para SAINT® TMS | Neuro Wellness",
      },
      {
        name: "description",
        content:
          "Viaje a Coral Springs, FL para SAINT® TMS: por qué un protocolo de 5 días hace práctico el viaje, el calendario de la semana de tratamiento, aeropuertos.",
      },
      {
        property: "og:title",
        content: "Viaje a Coral Springs para SAINT® TMS",
      },
      {
        property: "og:description",
        content:
          "Por qué un protocolo de 5 días de SAINT® hace práctico el viaje — calendario, aeropuertos, alojamiento y viajar con un acompañante.",
      },
      { property: "og:url", content: ES_URL },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "es_ES" },
      { name: "twitter:card", content: "summary_large_image" },
      {
        name: "twitter:title",
        content: "Viaje a Coral Springs para SAINT® TMS",
      },
      {
        name: "twitter:description",
        content:
          "Por qué un protocolo de 5 días de SAINT® hace práctico el viaje — calendario, aeropuertos, alojamiento y viajar con un acompañante.",
      },
    ],
    links: [
      { rel: "canonical", href: ES_URL },
      ...buildHreflang("/saint-tms-travel"),
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          buildMedicalWebPage({
            name: "Viaje a Coral Springs para SAINT® TMS",
            description:
              "Por qué un protocolo de 5 días de SAINT® TMS hace práctico el viaje para pacientes de otros estados — calendario, aeropuertos, alojamiento y viajar con un acompañante.",
            url: ES_URL,
            id: `${ES_URL}#webpage`,
            breadcrumbId: BREADCRUMB_ID,
          }),
        ),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify(
          buildBreadcrumbList(
            [
              { name: "Inicio", href: "/es" },
              { name: "SAINT® TMS", href: "/es/saint" },
              {
                name: "Viaje para SAINT® TMS",
                href: "/es/saint-tms-travel",
              },
            ],
            BREADCRUMB_ID,
          ),
        ),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "MedicalTherapy",
          "@id": `${SITE_URL}/saint#therapy`,
          name: "SAINT® Accelerated TMS",
          description:
            "TMS acelerada guiada por fMRI de 5 días, autorizada por la FDA, para adultos con trastorno depresivo mayor que no han logrado alivio adecuado con antidepresivos.",
          url: `${SITE_URL}/saint`,
          provider: CLINIC_REF,
        }),
      },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <SaintTmsTravelEs />;
}
